"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTable = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("../../components");
const constants_1 = require("../../constants");
const renderInlineText_1 = require("./renderInlineText");
function renderTable({ header, items }) {
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return renderInlineText_1.renderInlineText(constants_1.EMPTY_TEXT.dash);
    }
    return react_1.default.createElement(components_1.TableKeyValue, { header: header, items: items });
}
exports.renderTable = renderTable;
//# sourceMappingURL=renderTable.js.map